import { lib } from '@teacher/common-lib';
import { app } from '@lib/index';

const { instance } = app.http;

export default function handler(application) {
  instance.interceptors.response.use(
    async (result) => {
      const { $message, $alert } = application.config.globalProperties;
      const res = result.data;
      if (res && res.code !== 200) {
        // 未登录,重新登录
        if (res.code === 401) {
          if (result.config.url === '/api/cs-pc-crm/teacher/businessLogin') {
            lib.logout(true);
          } else {
            lib.dialogSingle(res.code, () => $alert(res.msg || '登录已失效，请重新登录', {
              showClose: false,
              type: 'warning',
            }).then(() => {
              lib.logout(true);
            }));
          }
          return Promise.reject(res);
        }

        if (res.code === 407) {
          lib.dialogSingle(res.code, () => $alert(res.msg || '您已从该机构离职，请重新登录', {
            showClose: false,
            type: 'warning',
          }).then(() => {
            lib.logout(true);
          }));
          return Promise.reject(res);
        }

        // 权限变更或无权限访问.
        // if (res.code === 403) {
        //   $alert(res.msg, { showClose: false, type: 'warning' }).then(() => {
        //     lib.logout();
        //   });
        //   return Promise.reject(res);
        // }

        // 60000以下自动报错.
        if (res.code <= 60000) {
          const clearMsg = setTimeout(() => {
            const msg = `${res.msg || res.code}`;
            if (msg.length <= 15) {
              // 错误处理
              lib.dialogSingle(res.code, () => $message.error(res.msg || res.code));
            } else {
              lib.dialogSingle(res.code, () => $alert(msg, '', { type: 'error', confirmButtonText: '我知道了' }));
            }
          }, 0);
          Object.setPrototypeOf(res, {
            clear: () => clearTimeout(clearMsg),
          });

          if (window.Sentry) {
            window.Sentry.captureMessage(
              JSON.stringify({
                url: result.config.url,
                params: result.config.data,
                result: result.data,
              }),
            );
          }

          return Promise.reject(res);
        }
      }
      return res;
    },
    (error) => {
      const { $message } = application.config.globalProperties;
      const err = error;
      if (err && err.response) {
        switch (err.response.status) {
          case 400:
            err.message = '请求错误';
            break;
          case 401:
            err.message = '授权失败，请检查token';
            break;
          case 403:
            err.message = '拒绝访问';
            break;
          case 404:
            err.message = `请求${err.response.config.url
              .split('/')
              .pop()
              .replace(/\.html/, '')}接口出错`;
            break;
          case 408:
            err.message = '请求超时';
            break;
          case 429:
            err.message = '操作过于频繁，请等待1-3秒再试~';
            break;
          case 500:
            err.message = '服务器内部错误';
            break;
          case 501:
            err.message = '服务未实现';
            break;
          case 502:
            err.message = '网关错误';
            break;
          case 503:
            err.message = '服务不可用';
            break;
          case 504:
            err.message = '网关超时';
            break;
          case 505:
            err.message = 'HTTP版本不受支持';
            break;
          default:
        }
        $message.error(err.message || '网络异常，请稍后重试');
      }

      if (window.Sentry) {
        window.Sentry.captureException(err);
      }
      return Promise.reject(err);
    },
  );

  function transUrl(url) {
    const newUrl = url.indexOf('/') !== 0 ? `/${url}` : url;
    const { ip } = app.tool.parseQuery();
    const proxy = ip ? `/${ip}` : '';

    return proxy + newUrl;
  }

  instance.interceptors.request.use(
    (config) => {
      // eslint-disable-next-line no-param-reassign
      config.url = transUrl(config.url);
      return config;
    },
    (error) => Promise.reject(error),
  );
}

// 为了与后端调试方便
const { name } = app.tool.parseQuery();
if (name) {
  app.http.setHeader('x3-version', name);
}
app.http.setHeader('yunxiao-version', '3.51');
